export default __webpack_public_path__ + "static/media/up1rhohd 1.d1147571.svg";